'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _soucheUtil = require('@souche-f2e/souche-util');

var _soucheUtil2 = _interopRequireDefault(_soucheUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUrlSpm = function getUrlSpm() {
    var params = _soucheUtil2.default.getParams(location.href);
    if (params.a && params.b && params.c && params.d) {
        return params.a + '.' + params.b + '.' + params.c + '.' + params.d;
    }
    return params.spm || '';
};

var getDefaultParams = {
    spm: getUrlSpm(),
    success: null,
    uploadPosition: null,
    source: 'TANGECHE'
};

exports.default = {
    getParams: _soucheUtil2.default.getParams(),
    configData: {},
    getDefaultParams: getDefaultParams,
    setCookie: _soucheUtil2.default.setCookie,
    getCookie: _soucheUtil2.default.getCookie,
    setItem: function setItem(key, value) {
        try {
            sessionStorage.setItem(key, value);
        } catch (e) {
            // continue regardless of error
        }
    },
    getItem: function getItem(key) {
        try {
            return sessionStorage.getItem(key);
        } catch (e) {
            return '';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/souche-spm/dist/utils.js
// module id = qG6s
// module chunks = 8